import { Outlet, useParams } from 'react-router-dom'
import DataVisualization from '../DataVisualization'

/**
 * 资产数据区：列表与详情切换时保持列表组件挂载，避免筛选条件与表格数据丢失。
 */
const DataSection = () => {
  const { id } = useParams<{ id?: string }>()
  const showDetail = Boolean(id)

  return (
    <>
      <div hidden={showDetail}>
        <DataVisualization />
      </div>
      <Outlet />
    </>
  )
}

export default DataSection
